import React from "react";
import PropTypes from "prop-types";
export default function Navbar(props) {
  return (
    <div>
      <nav
        className={`navbar navbar-expand-lg navbar-dark bg-success `}
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            {props.title}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <link className="nav-link active" aria-current="page" to="/">
                </link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/Newabout">
                  {props.About}
                </a>
              </li>
            </ul>



            <div className="d-flex">
              <div className="bg-primary rounded mx-2" onClick={()=>{props.toggleMode('primary')}} style={{height:'30px', width: '30px', cursor:'pointer'}}></div>
              <div className="bg-info rounded mx-2" onClick={()=>{props.toggleMode('info')}} style={{height:'30px', width: '30px', cursor:'pointer'}}></div>
              <div className="bg-secondary rounded mx-2" onClick={()=>{props.toggleMode('secondary')}} style={{height:'30px', width: '30px', cursor:'pointer'}}></div>
              <div className="bg-dark rounded mx-2" onClick={()=>{props.toggleMode('dark')}} style={{height:'30px', width: '30px', cursor:'pointer'}}></div>
              <div className="bg-light rounded mx-2" onClick={()=>{props.toggleMode('light')}} style={{height:'30px', width: '30px', cursor:'pointer'}}></div>
            </div>


            <form className="d-flex">
              <input
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button className="btn btn-outline-success mx-3" type="submit">
                Search
              </button>
            </form>
            {/* <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                onClick={props.toggleMode}
              />
              <label className="form-check-label"  htmlFor="flexSwitchCheckDefault">
                Enable Dark Mode
              </label>
            </div> */}
          </div>
        </div>
      </nav>
    </div>
  );
}
Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  // Home: PropTypes.string.isRequired,
  About: PropTypes.string.isRequired,
};
Navbar.defaultProps = {
  title: "set the title",
  About: "About Us",
};
